import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import PartClaimFormCA from './PartClaimFormCA';
import { accountsSel, userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    userAccounts: accountsSel(state),
    userData: userDataSel(state)
  };
};

export const pureComponent = PartClaimFormCA;
export default connect(mapStateToProps)(withI18n()(PartClaimFormCA));
